import { useTranslation } from 'react-i18next'
import { isPast } from 'date-fns'

import { Badge, type BadgeVariant } from '@percent/lemonade'
import type {
  GivingCampaignPartnerDto,
  GivingCampaignStatusDto
} from '@percent/workplace-giving/api/campaigns/campaign.types'

const getVariant = ({ status, endDate }: { status: GivingCampaignStatusDto; endDate: string | null }): BadgeVariant => {
  if (status === 'PUBLISHED' && endDate && isPast(new Date(endDate))) return 'default'

  if (status === 'PUBLISHED') return 'positive'

  if (status === 'DRAFT') return 'default'

  if (status === 'CANCELLED') return 'critical'

  return 'default'
}

const getTranslationKey = ({ status, endDate }: { status: GivingCampaignStatusDto; endDate: string | null }) => {
  if (status === 'PUBLISHED' && endDate && isPast(new Date(endDate))) return 'workplace_giving.myCampaigns.status.past'

  if (status === 'PUBLISHED') return 'workplace_giving.myCampaigns.status.published'

  if (status === 'DRAFT') return 'workplace_giving.myCampaigns.status.draft'

  if (status === 'CANCELLED') return 'workplace_giving.myCampaigns.status.cancelled'

  return 'workplace_giving.myCampaigns.status.draft'
}

export function StatusBadge({ campaign }: { campaign: GivingCampaignPartnerDto }) {
  const { t } = useTranslation()

  return (
    <Badge variant={getVariant({ status: campaign.status, endDate: campaign.endDate })} shape="oval">
      {t(getTranslationKey({ status: campaign.status, endDate: campaign.endDate }))}
    </Badge>
  )
}
